import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Crosshair, MessageSquare, PenTool, Factory } from "lucide-react";
import "./ReinforcementSection.css";

const BENEFITS = [
  { icon: Crosshair, title: "Intervention ciblée", text: "Sur un dossier, une surcharge ou une étape précise." },
  { icon: MessageSquare, title: "Échange direct", text: "Un interlocuteur unique, sans intermédiaire." },
  { icon: PenTool, title: "Maîtrise CAO / DAO", text: "Modèles 3D et plans exploitables par votre équipe." },
  { icon: Factory, title: "Approche orientée fabrication", text: "Des choix de conception pensés pour l'atelier." },
];

const ReinforcementSection = () => (
  <section className="renfort s-section" id="renfort" aria-labelledby="renfort-title" data-testid="renfort-section">
    <div className="s-container renfort-inner">
      <div className="renfort-copy">
        <p className="s-label reveal">Renfort BE</p>
        <h2 id="renfort-title" className="s-title reveal" data-delay="1">
          Externalisation
          <br />
          bureau d'études
        </h2>
        <p className="s-lead reveal" data-delay="2">
          Besoin ponctuel de ressources supplémentaires&nbsp;? SI2T intervient en appui de votre bureau d'études pour
          absorber une surcharge, reprendre un dossier ou produire les éléments nécessaires à la fabrication.
        </p>

        <ul className="renfort-benefits" data-testid="renfort-benefits">
          {BENEFITS.map(({ icon: Icon, title, text }, i) => (
            <li key={title} className="renfort-benefit reveal" data-delay={i + 1}>
              <span className="renfort-benefit-icon">
                <Icon size={20} strokeWidth={1.8} aria-hidden="true" />
              </span>
              <div>
                <h3>{title}</h3>
                <p>{text}</p>
              </div>
            </li>
          ))}
        </ul>

        <div className="renfort-actions reveal" data-delay="3">
          <Link to="/#contact" className="btn btn-primary" data-testid="renfort-cta">
            Parler de votre besoin
            <ArrowRight size={16} strokeWidth={2.2} />
          </Link>
        </div>
      </div>

      <figure className="renfort-figure reveal" data-delay="2">
        <div className="renfort-figure-frame">
          <img
            src="/img/poste-be-800.webp"
            srcSet="/img/poste-be-480.webp 480w, /img/poste-be-800.webp 800w"
            sizes="(max-width: 1100px) 92vw, 560px"
            alt="Poste de travail CAO avec modèle 3D à l'écran, plans et maquette sur le bureau"
            loading="lazy"
            width="800"
            height="251"
            className="img-cover"
          />
        </div>
        <figcaption>
          <span className="demo-tag">Visuel de démonstration</span>
          <span className="renfort-figure-caption">Poste CAO / DAO · modèle 3D, mise en plan, dossier technique</span>
        </figcaption>
        <ul className="renfort-figure-list" aria-label="Formats échangés">
          <li>STEP</li>
          <li>PDF</li>
          <li>DXF</li>
          <li>DWG</li>
        </ul>
      </figure>
    </div>
  </section>
);

export default ReinforcementSection;
